
import { ControlElement } from '@jsonforms/core';
import { defineComponent } from 'vue';
import { rendererProps, RendererProps, useJsonFormsControl } from '@jsonforms/vue';
import { useValidate, useErrors } from '../../util';

const controlRenderer = defineComponent({
  name: 'date-control-renderer',
  props: {
    ...rendererProps<ControlElement>(),
    dateCanBeEdit: { type: Boolean, default: false },
    isNewEl: { type: Boolean, default: false },
    dataElement: { type: Object },
  },
  setup(props: RendererProps<ControlElement>) {
    const input = useJsonFormsControl(props);
    useValidate(input.control);
    const { listErrors } = useErrors();
    return { ...input, listErrors };
  },
  data() {
    return {
      date: undefined,
      isTouched: false,
    };
  },
  computed: {
    hasError(): boolean {
      if (this.control.uischema?.options?.hideError) {
        return false;
      }
      return !!(this.control.errors || this.listErrors.filter(error => error.source === this.control.path).length);
    },
    errorMessage(): string {
      return [this.control.errors, ...this.listErrors.filter(error => error.source === this.control.path).map(error => error.message)].filter(Boolean).join(', ');
    },
  },
  methods: {
    onBlur() {
      this.isTouched = true;
    },
    onFocus() {
      // Optionally mark as touched on focus
    },
    onDateChange(value: string | undefined) {
      this.isTouched = true;
      this.onChange(value);
    },
    onChange(value: string | undefined) {
      // this.validate(value);
      this.handleChange(this.control.path, value || undefined);
    },
  },
});

export default controlRenderer;
